import React, { useRef } from "react";
import { ReactTFC } from "../../utils/fp/missing-ts-parts";

import { Global } from "@emotion/react";

import { ContentContainer } from "../../components/_shared-components/arrangement/Container";
import { SwarovskiButton } from "../../components/_shared-components/ui-elements/SwarovskiButton";
import { GeneralTranslation, type TranslatedValue } from "@swo/storefront";
import { HeaderSpacer } from "../_layout-helpers/spacers";
import { Spacer } from "../../components/_shared-components/arrangement/Space";
import { FooterEnd } from "../../components/FooterComponent/subcomponents/FooterEnd";
import { EmptyHeaderComponent } from "../../components/HeaderComponent/EmptyHeaderComponent";
import { getGlobalFontStyles } from "../../styles/styles-global";
import { GenericNotFoundPageLayoutShell } from "./GenericNotFoundPageLayoutShell";
import { T } from "../../components/T";

export type NotFoundPageTranslations = {
  "notFound.headline": string | TranslatedValue;
  "notFound.paragraph": string | TranslatedValue;
  "notFound.goBackButtonLabel": string | TranslatedValue;
};

export const GenericNotFoundPageLayout: ReactTFC<{
  translations: NotFoundPageTranslations;
}> = props => {
  return (
    <>
      <Global styles={getGlobalFontStyles("en")} />
      <EmptyHeaderComponent />

      <HeaderSpacer />
      <Spacer size={"md"} />

      <ContentContainer className={"expand"}>
        <GenericNotFoundPageLayoutShell
          headline={<T>{props.translations["notFound.headline"]}</T>}
          paragraph={<T>{props.translations["notFound.paragraph"]}</T>}
        >
          <SwarovskiButton as={"a"} isInternal={false} link={"/"} variant={"green"}>
            <T>{props.translations["notFound.goBackButtonLabel"]}</T>
          </SwarovskiButton>
        </GenericNotFoundPageLayoutShell>
      </ContentContainer>

      <FooterEnd />
    </>
  );
};
